import React, {Component} from 'react';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import Input from '../../components/Forms/Input.jsx';
import SelectField from 'material-ui/SelectField';
import RaisedButton from 'material-ui/RaisedButton';
import dateformat from 'dateformat';

const items = [
    <MenuItem key={0} value={null} primaryText="" />,
  <MenuItem key={1} value={1} primaryText="Transferencia" />,
  <MenuItem key={2} value={2} primaryText="Deposito" />,
  <MenuItem key={3} value={3} primaryText="Cheque" />,
  <MenuItem key={4} value={4} primaryText="Retención de I.V.A." />,
  <MenuItem key={5} value={5} primaryText="Retención de I.S.L.R." />,
];

class NewPago extends Component {
    render() {
        if (!this.props.show) return null;

        const tipos = this.props.tipos.map((tipo) => {
            return <MenuItem key={tipo.id} value={tipo.id} primaryText={tipo.descripcion} />
        });
        return (
            <Paper style={this.props.paperStyle}>
                <h2 className="center">Cargar Pago / Retención</h2>
                <form action="/user/suscripcion/pago" method="post" onSubmit={this.props.onSubmit}>
                    <SelectField
                        defaultSelected={0}
                        floatingLabelStyle={{color:'rgb(97, 97, 97)'}}
                        underlineStyle={{borderColor:'rgb(187, 187, 187)'}}
                        value={this.props.pago.tipo_pago_id}
                        onChange={this.props.onInputChange}
                        floatingLabelText="Tipo de Pago / Retención"
                        fullWidth={true} 
                        name="tipo_pago_id">
                        {tipos}
                    </SelectField>
                
                    <Input
                        validations="required"
                        val={this.props.pago.monto}
                        onChange={this.props.onInputChange}
                        name="monto"
                        floatingLabelText="Monto"
                        fullWidth={true} 
                        />

                    <Input
                        validations="required"
                        date={true}
                        locale={navigator.language}
                        DateTimeFormat={Intl.DateTimeFormat}
                        formatDate={(date) => dateformat(date, 'dd-mm-yyyy')}
                        val={this.props.pago.fecha}
                        onChange={this.props.onInputChange}
                        name="fecha"
                        floatingLabelText="Fecha"
                        fullWidth={true} 
                        />

                    <Input
                        validations="required"
                        val={this.props.pago.numero_documento}
                        onChange={this.props.onInputChange}
                        name="numero_documento"
                        floatingLabelText="Número (Transferencia, Depósito, Retención)"
                        fullWidth={true} 
                        />

                    <div style={{width:'100%', marginTop:20}} className="file">
                        <label  htmlFor="soporte"> Soporte <br/> 
                        <span style={{fontSize:12}}>
                            (Imágenes(JPG, PNG, GIF) o PDF no superiores a 1000 kb.)
                        </span>
                        </label>
                        <input
                            validations="required"
                            files={this.props.pago.soporte}
                            onChange={this.props.onInputChange}
                            style={{width:'100%', marginTop:10}}
                            name="soporte"
                            type="file" 
                            />
                    </div>

                    <RaisedButton 
                        label="Enviar" 
                        type="submit" 
                        primary={true} 
                        style={{marginTop:20}} />
                </form>
            </Paper>
        );
    }
}

export default NewPago;


/** WEBPACK FOOTER **
 ** ./app-react/components/Suscripcion/NewPago.jsx
 **/